import React from 'react';
import { Box, Typography } from '@mui/material';

interface CertLink {
  label: string;
  url: string;
}

interface Certificate {
  title: string;
  organization: string;
  date: string;
  links?: CertLink[];
  note?: string;
}

export const Certifications: React.FC = () => {
  const certificates: Certificate[] = [
    {
      title: 'LLM Levels 1–3 & Large Language Models',
      organization: 'H2O.ai',
      date: '2024',
      links: [
        { label: 'L1', url: 'https://eu.badgr.com/public/assertions/HgnnxNHyQsGn4dwQPwBpXA' },
        { label: 'L2', url: 'https://eu.badgr.com/public/assertions/TDOURDJ5Q-eazJuDxQH6Bg' },
        { label: 'L3', url: 'https://eu.badgr.com/public/assertions/LnQ-pz7TQ52i4UAcIjd8xA' },
        { label: 'LLMs', url: 'https://api.eu.badgr.io/public/assertions/qmTdRE_nQ9qAraoVI9Hc1A' }
      ]
    },
    {
      title: 'ML Interpretability',
      organization: 'H2O.ai',
      date: '2020',
      links: [{ label: 'verify', url: 'https://bcert.me/scasljtgo' }]
    },
    {
      title: 'Deep Learning Specialization',
      organization: 'Coursera / deeplearning.ai',
      date: '2017',
      note: '4 courses'
    },
    {
      title: 'Data Science Specialization',
      organization: 'Coursera / Johns Hopkins University',
      date: '2015',
      note: '8 courses'
    }
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{
        mb: 3,
        color: '#FFFFFF',
        fontFamily: '"Inter", sans-serif'
      }}>
        Certifications
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 1 }}>
        {certificates.map((cert) => (
          <Box
            component="li"
            key={cert.title}
            sx={{
              display: 'grid',
              gridTemplateColumns: '56px 1fr',
              gap: 2,
              alignItems: 'baseline',
            }}
          >
            <Typography sx={{ color: '#78909C', fontFamily: '"JetBrains Mono", monospace', fontSize: '13px' }}>
              {cert.date}
            </Typography>
            <Typography component="div" sx={{ fontSize: '14px', color: '#B0BEC5', lineHeight: 1.6 }}>
              <Box component="span" sx={{ color: '#FFFFFF', fontWeight: 500 }}>{cert.title}</Box>
              {' · '}{cert.organization}
              {cert.note && ` · ${cert.note}`}
              {cert.links && cert.links.map((link) => (
                <Box
                  key={link.label}
                  component="a"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-print"
                  sx={{
                    ml: 1,
                    color: '#00D4FF',
                    fontFamily: '"JetBrains Mono", monospace',
                    fontSize: '12px',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  {link.label} ↗
                </Box>
              ))}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
